import {gql} from '@apollo/client/core';

export const VismaOrderDetailsV2 = gql`
  fragment vismaOrderDetailV2 on VismaOrderDetailV2 {
    id
    visualOrderId
    vismaOrderNumber
    orderDate
    orderStatus
    storeName
    orderTotal
    vatTotal
    orderComment
    deliveryPrice
    discounts {
      id
      amount
      name
    }
    invoiceData {
      id
      customerNumber
      customerName
      customerType
      companyName
      customerEanNumber
      customerEmail
      customerPhone
      customerAddress
      customerZip
      customerCity
      customerCountryCode
      invoiceDate
      paymentMethod
    }
    deliveryData {
      id
      deliveryName
      deliveryAddress {
        deliveryAddress
        deliveryZip
        deliveryCity
        deliveryCountryCode
      }
      deliveryComment
      deliveryMethod
      deliveryDate
      trackAndTraceLink
    }
    invoiceFile {
      id
      invoiceNumber
      invoiceUrl
    }
    orderLines {
      id
      vismaOrderNumber
      lineNumber
      vismaProductNumber
      productTitle
      quantity
      unitPrice
      unitType
      lineTotal
      productImage {
        id
        height
        width
        large
        original
        small
        thumbnail
      }
    }
  }
`;
